import { render } from "./CondicionesCovid.vue?vue&type=template&id=58f16428&scoped=true"
import script from "./CondicionesCovid.vue?vue&type=script&lang=js"
export * from "./CondicionesCovid.vue?vue&type=script&lang=js"

import "./CondicionesCovid.vue?vue&type=style&index=0&id=58f16428&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f16428"]])

export default __exports__